<template>
  <div>
    <logged-in-header />
    <billing-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import billingPanel from "../components/billing/BillingPanel";

export default {
  components: {
    loggedInHeader,
    billingPanel
  }
};
</script>
